<template>
  <div
    :class="`as-progress-bar as-progress-bar-${siteName}`"
    :style="progressStyle"
  ></div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { IMatch } from "~src/interfaces";
import { usecommonStore } from "~src/stores/CommonStore";
const commonStore = usecommonStore();
interface Props {
  match: IMatch;
}

const props = defineProps<Props>();
const siteName = computed(() => commonStore.getSiteName);

const width = computed(() => {
  // if (props.match.match_time_player) {
  //   if (props.match.match_time_player.process < 20) {
  //     value = 20;
  //   } else if (props.match.match_time_player.process > 95) {
  //     value = 95;
  //   } else {
  //     value = props.match.match_time_player.process;
  //   }
  // }

  let value = props.match?.match_time_player?.process ?? 0;
  return value;
});

const borderBottomRightRadius = computed(() => {
  let value = 0;
  if (props.match.match_time_player) {
    if (props.match.match_time_player.process > 90) {
      value = 45;
    } else if (props.match.match_time_player.process > 80) {
      value = 20;
    }
  }
  return value;
});

const progressStyle = computed(() => {
  let _clip_path = "";
  const array = ["xoilacz", "rakhoi", "xoilac86", "soco", "vebo", "mitom", "vaoroi", "xoilacvi", "xoilacvnn"];
  if (array.includes(siteName.value)) {
    if (width.value < 26) {
      _clip_path = "polygon(0% 0%, 100% 0%, 12px 100%, 12px 100%)";
    }
  }
  return {
    position: "absolute",
    left: "3px",
    top: "2px",
    height: "86%",
    borderBottomLeftRadius: "60px",
    width: `${width.value}%`,
    borderBottomRightRadius: `${borderBottomRightRadius.value}px`,
    clipPath: _clip_path,
  };
});
</script>

<script lang="ts">
export default {};
</script>
